@if (prevention$ | async; as prevention) {
  <div class="prevention">
    <div class="prevention-header">
      <div class="prevention-header-title">
        <div class="prevention-header-title-text" style="display: flex" appLongTextTooltip>AI RAG File Analysis</div>
      </div>

      <div class="prevention-header-secondary-title">
        <div class="prevention-header-secondary-title-property">
          <div>Flagged as malicious {{ prevention.discoveredDate | date: 'MMM d, y, HH:mm:ss' }}</div>
        </div>
      </div>
    </div>
    <div class="prevention-body">
      @if (activeTabIndex === 0) {
        <div class="prevention-body-tab">
          <div class="prevention-body-tab-card prevention-details-card">
            <div class="prevention-body-tab-card-title">File Details</div>
            <app-card-fields [cardFields]="preventionDetailsCardFields" />
          </div>
          <div class="prevention-body-tab-card-title">Content Analysis</div>
          <div class="prevention-body-tab-card prevention-code-analysis" [innerHtml]="prevention.contentAnalysis"></div>
        </div>
      }
    </div>
  </div>

  @if (showNoData) {
    <div class="no-data-container">
      <app-no-data [inDialog]="true"></app-no-data>
    </div>
  }
} @else {
  <div class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
}
